import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import BEM from "./TextPage.module.css";

export const PageBase = ({ heading, children, className, style }) => {
    return (
        <article className={className} style={style}>
            <div className={BEM.top}>
                <Link to="/" className={BEM.homeLink}>
                    🏠 <strong>Go home</strong>
                </Link>

                {heading && <h1 className={BEM.heading}>{heading}</h1>}
            </div>

            <div className={BEM.childrenContainer}>{children}</div>
        </article>
    );
};

PageBase.propTypes = {
    heading: PropTypes.node,
    className: PropTypes.string,
    style: PropTypes.object,
};
